import { Box, Skeleton } from "@mui/material";

interface Props {
  /** Renglones del texto que se está cargando; el último va más corto. */
  lineas: number;
}

/** Renglones de texto mientras cargan los textos legales de la empresa (`useTextosLegales`). */
export const SkeletonTextoLegal = ({ lineas }: Props) => (
  <Box component="span" sx={{ display: "block", width: "100%" }}>
    {Array.from({ length: lineas }, (_, index) => (
      <Skeleton key={index} variant="text" animation="wave" width={index === lineas - 1 ? "60%" : "100%"} />
    ))}
  </Box>
);
